export const OwnerUserResource = {
  id: '',
  full_name: '',
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  phone_number: '',
}
